//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "certificateBox",
    props: {
        isShowCert: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        certificate() {
            this.$router.push({path: '/certificate'})
        },
    },
    created() {
        this.show = this.isShowCert;
    },
    watch: {
        isShowCert(o, n) {
            this.show = this.isShowCert;
        }
    }
}
